import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import AnimatedBack from "../images/AnimatedBack.gif";
import HR1 from "../images/HR1.png";
import HR2 from "../images/HR2.png";
import HR3 from "../images/HR3.png";
import HR4 from "../images/HR4.png";
import HR5 from "../images/HR5.png";
import HR6 from "../images/HR6.png";
import HR7 from "../images/HR7.png";
import HR8 from "../images/HR8.png";
import HR9 from "../images/HR9.png";
import HR10 from "../images/HR10.png";
import HR11 from "../images/HR11.png";
import HR12 from "../images/HR12.png";
import HR13 from "../images/HR13.png";
import HR14 from "../images/HR14.png";
import HR15 from "../images/HR15.png";
import HR16 from "../images/HR16.png";

function HireResources() {
  return (
    <>
      <Header />
      <div className="GD">
        <div className="Webd-above">
          <img className="Webd-img" src={AnimatedBack} alt="" />
          <div className="Webd-above-info">
            <p className="Webd-p">PHP Web Development</p>
            <p
              className="Webd-p"
              style={{ marginTop: "-20px", marginBottom: "30px" }}
            >
              we’re experts
            </p>
            <p className="Webd-p1">
              Exceeding Expectations of a PHP Development Company
            </p>
          </div>
        </div>
        <div className="Webd-main2">
          <p className="Webd-main2-p">Mobile App Development Services</p>
          <p className="Webd-main2-p1">
            Obtain Mobile App Services to Expand Your Business Worldwide.
          </p>
          <div className="Appd-main2-boxes" style={{ textAlign: "left" }}>
            <div className="Appd-main2-box">
              <img
                className="Appd-main2-img"
                src={HR1}
                style={{ marginLeft: "70px" }}
                alt="Full Time Hiring"
              />
              <p
                style={{
                  color: "black",
                  fontWeight: "bold",
                  fontSize: "24px",
                  marginLeft: "30px",
                  marginBottom: "30px",
                }}
              >
                Full Time Hiring
              </p>
              <p>
                <strong>Duration:</strong> 8/hours per day, 5 days/week
              </p>
              <p>
                <strong>Hiring Period:</strong> Minimum 1 Month
              </p>
              <p>
                <strong>Communication:</strong> Email, Skype, Phone
              </p>
              <p>
                <strong>Billing:</strong> Monthly
              </p>
            </div>
            <div className="Appd-main2-box">
              <img
                className="Appd-main2-img"
                src={HR2}
                style={{ marginLeft: "60px" }}
                alt="Part Time Hiring"
              />
              <p
                style={{
                  color: "black",
                  fontWeight: "bold",
                  fontSize: "24px",
                  marginLeft: "30px",
                  marginBottom: "30px",
                }}
              >
                Part Time Hiring
              </p>
              <p>
                <strong>Duration:</strong> 4/hours per day, 5 days/week
              </p>
              <p>
                <strong>Hiring Period:</strong> Minimum 1 Month
              </p>
              <p>
                <strong>Communication:</strong> Email, Skype, Phone
              </p>
              <p>
                <strong>Billing:</strong> Monthly
              </p>
            </div>
            <div className="Appd-main2-box">
              <img
                className="Appd-main2-img"
                src={HR3}
                style={{ marginLeft: "50px" }}
                alt="Hourly Hiring"
              />
              <p
                style={{
                  color: "black",
                  fontWeight: "bold",
                  fontSize: "24px",
                  marginLeft: "30px",
                  marginBottom: "30px",
                }}
              >
                Hourly Hiring
              </p>
              <p>
                <strong>Communication:</strong> Email, Skype, Phone
              </p>
              <p>
                <strong>Billing:</strong> Hourly
              </p>
              <p>
                <strong>Hiring Period:</strong> Minimum 25 Hours
              </p>
            </div>
          </div>
        </div>
        <div className="Customer-head">
          <div className="Customer-head-info">
            <p style={{ fontSize: "42px", fontWeight: "bolder" }}>
              Want a custom solution?
            </p>
            <p>HIRE DEDICATED DEVELOPERS</p>
          </div>
          <div className="Customer-head-links" style={{ marginTop: "30px" }}>
            <div
              className="Customer-head-link"
              style={{ paddingRight: "50px" }}
            >
              <p>Contact Us</p>
            </div>
          </div>
        </div>
        <div className="Webd-main2" style={{ backgroundColor: "#e9ecef" }}>
          <p className="Webd-main2-p" style={{ paddingTop: "50px" }}>
            Employ a Skilled Web Developer in 5 Simple Steps
          </p>
          <p className="Webd-main2-p1">
            At Purohit Technosoft Software Solutions, we create custom Android
            apps to meet the evolving needs of the modern business landscape.
          </p>
          <div className="Appd-main2-boxes" style={{ marginLeft: "-40px" }}>
            <div
              className="Appd-main2-box"
              style={{ backgroundColor: "white", marginBottom: "40px" }}
            >
              <img className="Appd-main2-img" src={HR4} alt="" />
              <p
                style={{
                  color: "black",
                  fontWeight: "bold",
                  fontSize: "24px",
                }}
              >
                Post Requirements
              </p>
              <p style={{ marginTop: "20px" }}>
                Please fill out the enquiry form so we can understand your
                project and resource requirements.
              </p>
            </div>
            <div
              className="Appd-main2-box"
              style={{ backgroundColor: "white", marginBottom: "40px" }}
            >
              <img className="Appd-main2-img" src={HR5} alt="" />
              <p
                style={{
                  color: "black",
                  fontWeight: "bold",
                  fontSize: "24px",
                }}
              >
                Screen Resumes
              </p>
              <p style={{ marginTop: "20px" }}>
                Multiple resumes are sent to you. Shortlist the candidates
                meeting your expectations.
              </p>
            </div>
            <div
              className="Appd-main2-box"
              style={{ backgroundColor: "white", marginBottom: "40px" }}
            >
              <img className="Appd-main2-img" src={HR6} alt="" />
              <p
                style={{
                  color: "black",
                  fontWeight: "bold",
                  fontSize: "24px",
                }}
              >
                Interview & Select
              </p>
              <p style={{ marginTop: "20px" }}>
                Conduct in-person interviews with the shortlisted candidates and
                select the most suitable resource.
              </p>
            </div>
            <div
              className="Appd-main2-box"
              style={{ backgroundColor: "white", marginBottom: "40px" }}
            >
              <img className="Appd-main2-img" src={HR7} alt="" />
              <p
                style={{
                  color: "black",
                  fontWeight: "bold",
                  fontSize: "24px",
                }}
              >
                Choose Hiring Model
              </p>
              <p style={{ marginTop: "20px" }}>
                Select your preferred hiring and engagement models
              </p>
            </div>
            <div
              className="Appd-main2-box"
              style={{ backgroundColor: "white", marginBottom: "40px" }}
            >
              <img className="Appd-main2-img" src={HR8} alt="" />
              <p
                style={{
                  color: "black",
                  fontWeight: "bold",
                  fontSize: "24px",
                }}
              >
                Pay & Get Started
              </p>
              <p style={{ marginTop: "20px" }}>
                Make a secure payment and begin working with your chosen app
                developer.
              </p>
            </div>
          </div>
        </div>
        <div className="Webd-main2">
          <p className="Webd-main2-p">Why should you hire Dedicated Developers India from us?</p>
          <p className="Webd-main2-p1">Top Companies rely on constant for important projects beacause we deliver.
          </p>
          <div className="Webd-main2-boxes" style={{marginLeft:"-10px",marginRight:"10px"}}>
            <div className="Webd-main2-box">
              <img className="Webd-main2-img" src={HR9} alt="" />
              <p
                style={{
                  color: "black",
                  fontWeight: "bold",
                  fontSize: "24px",
                }}
              >
                Certified Experts
              </p>
              <p style={{ marginTop: "20px" }}>
                The largest team of certified professionals and industry
                experts, each highly skilled in their respective fields.
              </p>
            </div>
            <div className="Webd-main2-box">
              <img className="Webd-main2-img" src={HR10} alt="" />
              <p
                style={{
                  color: "black",
                  fontWeight: "bold",
                  fontSize: "24px",
                }}
              >
                Robust Infrastructure in Place
              </p>
              <p style={{ marginTop: "20px" }}>
                A dedicated in-house team specializing in web and mobile app
                development, equipped with all the necessary hardware and
                software infrastructure.
              </p>
            </div>
            <div className="Webd-main2-box">
              <img className="Webd-main2-img" src={HR11} alt="" />
              <p
                style={{
                  color: "black",
                  fontWeight: "bold",
                  fontSize: "24px",
                }}
              >
                Daily Reporting and Direct Oversight
              </p>
              <p style={{ marginTop: "20px" }}>
                With a dedicated resource, the client can maintain direct and
                transparent communication with the developer.
              </p>
            </div>
            <div className="Webd-main2-box">
              <img className="Webd-main2-img" src={HR12} alt="" />
              <p
                style={{
                  color: "black",
                  fontWeight: "bold",
                  fontSize: "24px",
                }}
              >
                Secure Development Environment
              </p>
              <p style={{ marginTop: "20px" }}>
                Clients are guaranteed full protection of their intellectual
                property and a secure development environment.
              </p>
            </div>
          </div>
          <div className="Webd-main2-boxes" style={{marginLeft:"-10px",marginRight:"10px"}}>
            <div className="Webd-main2-box">
              <img className="Webd-main2-img" src={HR13} alt="" />
              <p
                style={{
                  color: "black",
                  fontWeight: "bold",
                  fontSize: "24px",
                }}
              >
                Substantial Cost Savings
              </p>
              <p style={{ marginTop: "20px" }}>
                With strong leadership overseeing a team of dedicated
                developers, clients can enjoy the best pricing options without
                worrying about hidden overheads.
              </p>
            </div>
            <div className="Webd-main2-box">
              <img className="Webd-main2-img" src={HR14} alt="" />
              <p
                style={{
                  color: "black",
                  fontWeight: "bold",
                  fontSize: "24px",
                }}
              >
                Complete Flexibility
              </p>
              <p style={{ marginTop: "20px" }}>
                You have the flexibility to manage resources according to your
                needs and make changes until you are completely satisfied.
              </p>
            </div>
            <div className="Webd-main2-box">
              <img className="Webd-main2-img" src={HR15} alt="" />
              <p
                style={{
                  color: "black",
                  fontWeight: "bold",
                  fontSize: "24px",
                }}
              >
                Remote Project Management
              </p>
              <p style={{ marginTop: "20px" }}>
                With online project management tools like JIRA, GitLab, and
                Hubstaff, clients can easily track the progress of their
                dedicated resource and project, eliminating the need for offline
                follow-ups.
              </p>
            </div>
            <div className="Webd-main2-box">
              <img className="Webd-main2-img" src={HR16} alt="" />
              <p
                style={{
                  color: "black",
                  fontWeight: "bold",
                  fontSize: "24px",
                }}
              >
                Flexible Selection Process
              </p>
              <p style={{ marginTop: "20px" }}>
                After selecting resumes based on their business needs, our
                clients have full control over the interview process and can
                hire only if they are fully satisfied.
              </p>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default HireResources;
